var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { XLoader } from '../loader/XLoader';
import { NavLink } from 'react-router-dom';
import { useRouter } from '../../hooks/useRouter';
import { XIcon } from '../icon/XIcon';
export function XButton(props) {
    var _a;
    var type = props.type, variant = props.variant, color = props.color, size = props.size, disabled = props.disabled, isLoading = props.isLoading, children = props.children, className = props.className, fullWidth = props.fullWidth, to = props.to, icon = props.icon, appendIcon = props.appendIcon, rest = __rest(props, ["type", "variant", "color", "size", "disabled", "isLoading", "children", "className", "fullWidth", "to", "icon", "appendIcon"]);
    var router = useRouter();
    type = type !== null && type !== void 0 ? type : 'button';
    color = color !== null && color !== void 0 ? color : 'default';
    size = size !== null && size !== void 0 ? size : 0;
    var isRoute = Boolean(to);
    var iconOnly = Boolean(icon && !children);
    if (iconOnly) {
        variant = variant !== null && variant !== void 0 ? variant : 'text';
    }
    else {
        variant = variant !== null && variant !== void 0 ? variant : 'filled';
    }
    if (isLoading) {
        disabled = true;
    }
    var Element;
    if (isRoute) {
        var path = router.getRoute(to);
        if ((_a = path === null || path === void 0 ? void 0 : path.startsWith) === null || _a === void 0 ? void 0 : _a.call(path, 'http')) {
            Element = 'a';
            rest.href = path;
        }
        else {
            Element = NavLink;
            rest.to = path;
        }
    }
    else {
        Element = 'button';
    }
    return (React.createElement(Element, __assign({ className: clsx(className, "XButton x-size-" + size + " color-" + color + " variant-" + variant + " type-" + type, {
            isLoading: isLoading,
            fullWidth: fullWidth,
            disabled: disabled,
            iconOnly: iconOnly,
            prependIcon: Boolean(icon),
            appendIcon: Boolean(appendIcon),
        }), disabled: disabled }, rest),
        isLoading && React.createElement(XLoader, { size: size }),
        icon && React.createElement(XIcon, null, icon),
        children,
        appendIcon && React.createElement(XIcon, null, appendIcon)));
}
